import { lazy } from "react";
import { UserPlus } from "lucide-react";
import type { AdminModule } from "../types";

const Incomplete = lazy(() =>
  import("./pages/Incomplete").then((m) => ({ default: m.Incomplete })),
);

/**
 * Incomplete business signups. A provider who verified their email but never
 * created a business sits with users.business_id NULL, which breaks every
 * business-scoped screen for them and was invisible to us until they wrote in.
 * This lists them and resends the setup link.
 */
export const signupsModule: AdminModule = {
  key: "signups",
  label: "Signups",
  description: "Accounts stuck between verifying an email and having a business.",
  group: "customers",
  icon: UserPlus,
  requiredPermission: "admin.signups.read",
  routes: [{ path: "incomplete", label: "Incomplete", element: <Incomplete /> }],
};
